import {
    useCallback,
} from 'react'

import FormWithControls from 'app/shared-components/FormWithControls'
import StatusHandler from 'app/shared-components/StatusHandler'
import useHasPermission from 'app/hooks/useHasPermission'
import useDomainObjectContext from 'app/Apps/DomainObject/hooks/useDomainObjectContext'

import requests from 'app/requests/User.requests'
import useGetUser from '../hooks/useGetUser'
import getUserFormFields from '../UserForm.fields'

type Props = {
    id: string
}

const UserUpdate = ({
    id,
}: Props) => {
    const {
        updateTableElement,
    } = useDomainObjectContext()

    const updatePermission = useHasPermission(['user_create'])
    const {
        data,
        isDataReady,
        error,
        isError,
        invalidate,
        isFetching,
    } = useGetUser(id)

    const modifyDataBeforeSend = useCallback((update) => {
        updateTableElement(update)
        return {
            ...update,
            hint: undefined,
        }
    }, [updateTableElement])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                onSuccess={invalidate}
                value={data}
                name={requests.domainName}
                modifyDataBeforeSend={modifyDataBeforeSend}
                disabled={!updatePermission}
                fields={getUserFormFields(
                    updatePermission,
                )}
                requestParams={requests.update({
                    id,
                })}
                exists
            />
        </StatusHandler>
    )
}

export default UserUpdate
